export default __webpack_public_path__ + "static/media/To sign.f3feb24e.svg";